import httpClientGroups from '../api/httpClientGroups';

export const getAllGroups = async () => {
  const response = await httpClientGroups.get('/api/members/GroupManagement/GetAll');
  return response.data;
};

export const getGroupById = async (id) => {
  const response = await httpClientGroups.get(`/api/members/GroupManagement/GetById/${id}`);
  return response.data;
};

export const updateGroup = async ({ id, name, description }) => {
  const response = await httpClientGroups.put('/api/members/GroupManagement/Update', {
    id,
    name,
    description,
  });
  return response.data;
};

export const createGroup = async ({ name, description }) => {
  const response = await httpClientGroups.post('/api/members/GroupManagement/Create', {
    name,
    description,
  });
  return response.data;
};

export const deleteGroup = async (id) => {
  const response = await httpClientGroups.delete('/api/members/GroupManagement/Delete', { data: { id } });
  return response.data;
};

export const addMemberToGroup = async ({ groupId, memberId }) => {
  const response = await httpClientGroups.post('/api/members/GroupManagement/AddMember', { groupId, memberId });
  return response.data;
};

export const removeMemberFromGroup = async ({ groupId, memberId }) => {
  const response = await httpClientGroups.post('/api/members/GroupManagement/RemoveMember', { groupId, memberId });
  return response.data;
};

export const searchGroups = async ({ keyword } = {}) => {
  const response = await httpClientGroups.get('/api/members/GroupManagement/Search', { params: { keyword } });
  return response.data;
};

export const setGroupLeader = async ({ groupId, memberId }) => {
  const response = await httpClientGroups.post('/api/members/GroupManagement/SetLeader', {
    groupId,
    memberId,
  });
  return response.data;
};

export default {
  getAllGroups,
  getGroupById,
  updateGroup,
  createGroup,
  deleteGroup,
  addMemberToGroup,
  removeMemberFromGroup,
  searchGroups,
  setGroupLeader,
};


